
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import simplify from "@turf/simplify";
import LayerRoad		from "../classes/LayerRoad";

const DrawLineString = MapboxDraw.modes.draw_line_string;
const geojsonTypes = MapboxDraw.constants.geojsonTypes;
const cursors = MapboxDraw.constants.cursors;
const types = MapboxDraw.constants.types;
const updateActions = MapboxDraw.constants.updateActions;
const modes = MapboxDraw.constants.modes;
const events = MapboxDraw.constants.events;

let tempState;

const roadMode = Object.assign({}, DrawLineString)

roadMode.onSetup = function(opts) {
	opts = opts || {};
	
	let line, currentVertexPosition = (opts.startCoordinate ? 1 : 0);
	this.onFinish = opts.onFinish;
	if(opts.roads)
		this.roads = opts.roads;
	if(opts.toolRoad)
		this.toolRoad = opts.toolRoad;
	
	
	let direction = 'forward';
	
	line = this.newFeature({
		type: geojsonTypes.FEATURE,
		properties: {
			width:roadMode.user_width
		},
		geometry: {
			type: geojsonTypes.LINE_STRING,
			coordinates: opts.startCoordinate ? [opts.startCoordinate] : []
		},
		id:'added_road'
	});


	this.addFeature(line);
	
	this.clearSelectedFeatures();
		

	this.updateUIClasses({ mouse: cursors.ADD });
	this.setActionableState({
		trash: true
	});

	var state = {
		line,
		currentVertexPosition: currentVertexPosition,
		dragMoving: false,
		direction
	}
	if(opts.handles && opts.handles.length)
		this.onHandleClick(opts.handles, state);
	
	return state;
};

roadMode.onRightDrag =  function (e){
	tempState.dragMoving = true;
	tempState.line.updateCoordinate(tempState.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
	tempState.currentVertexPosition++;
	tempState.line.updateCoordinate(tempState.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
}




roadMode.onMouseDown = function(state, e) {
	
	tempState = state;
	
	if(e.originalEvent.which == 3){
		
		this.map.on("mousemove", roadMode.onRightDrag);
		this.map.on("mouseup", roadMode.onMouseUp.bind(this));
		
		
	}
  
};
roadMode.onMouseUp = function (state, e){
	if (!e && state.originalEvent.which == 3) {
		tempState.dragMoving = false;
		this.map.off("mousemove", roadMode.onRightDrag);
		//this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
	}
	else
		return;
}
roadMode.onHandleClick = function(handles, state) {
	
	if(handles.length){
		const featureId = handles[0].properties.roadid;
		const direction = handles[0].properties.position;
		
		var idx = this.roads.findIndex((p)=>{
			return p.roadid == featureId || (p.properties && p.properties.tempid == featureId);
		});

		if(idx>-1){
			const geo = structuredClone(this.roads[idx].geometry);
			
			geo.coordinates = geo.type == "MultiLineString" ? geo.coordinates[0] : geo.coordinates;
			
			if(direction == 1){
				
				if(state.line.coordinates.length<2){
					geo.coordinates.reverse();
					state.line.setCoordinates([...geo.coordinates, ...state.line.coordinates]);
				}
				else{
					state.line.coordinates.pop();
					state.line.setCoordinates([...state.line.coordinates, ...geo.coordinates]);
				}
			}
			else {
				if(state.line.coordinates.length<2){
					state.line.setCoordinates([...geo.coordinates]);
				}
				else{
					geo.coordinates.reverse();
					state.line.coordinates.pop();
					state.line.setCoordinates([...state.line.coordinates, ...geo.coordinates]);
				}
			}
			
			delete this.roads[idx].geometry;
			
			state.currentVertexPosition = state.line.coordinates.length;
			
			return; 	
		}
		
	}
}
roadMode.onIntersect = function(intersects, state, e){
	
	if(intersects.length){
		const coords = [e.lngLat.lng, e.lngLat.lat];
		
		const roadId = intersects[0].properties.roadid;
		var idx = this.roads.findIndex((p)=>{
			return p.roadid == roadId || (p.properties && p.properties.tempid == roadId);
		});

		if(idx>-1){
			const points = this.roads[idx].geometry.type == "MultiLineString" ? this.roads[idx].geometry.coordinates[0] : this.roads[idx].geometry.coordinates;
			
			const i = this.findIntersect(points, coords);
			
			if(i !== false){
				points.splice(i, 0, coords);
			}
			
			state.line.addCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
			this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
		}
	}	
}
roadMode.findIntersect = function(line, coords){
	

	var i = line.findIndex((c, idx)=>{
		
		if(line[idx+1]){
			return 	(
					(coords[0] >= c[0]  && coords[0] <= line[idx+1][0]) 
					|| 
					(coords[0] <= c[0]  && coords[0] >= line[idx+1][0])
				) && (
					(coords[1] >= c[1]  && coords[1] <= line[idx+1][1]) 
					|| 
					( coords[1] <= c[1]  && coords[1] >= line[idx+1][1])
				);
		
		}
		return false;
	});
	
	if(i > -1)
		return i+1;
	
	return false;
	
}
roadMode.clickOnVertex = function(state) {
  return this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
};
roadMode.clickAnywhere = function(state, e) {
	/*
	var handles = this.map.queryRenderedFeatures(e.point, {layers:[LayerRoad.handlesId]});
	
	var intersects = this.map.queryRenderedFeatures(e.point, {layers:[LayerRoad.bufferId]});
	
	
	if(handles && handles.length){
		this.onHandleClick(handles, state);
		return;
	}
	if(intersects && intersects.length){
		this.onIntersect(intersects, state, e);
		return;
	}
	*/
	
	if (state.currentVertexPosition > 0 && MapboxDraw.lib.isEventAtCoordinates(e, state.line.coordinates[state.currentVertexPosition - 1]) ||
		state.direction === 'backwards' && MapboxDraw.lib.isEventAtCoordinates(e, state.line.coordinates[state.currentVertexPosition + 1])) {
		return this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
	}
	this.updateUIClasses({ mouse: cursors.ADD });
	state.line.updateCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
	if (state.direction === 'forward') {
		state.currentVertexPosition++;
		state.line.updateCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
	}
	else {
		state.line.addCoordinate(0, e.lngLat.lng, e.lngLat.lat);
	}
};
roadMode.onTouchEnd = function(state, e) {
	this.onMouseUp(state, e)
}

roadMode.fireUpdate = function() {
	this.map.fire(events.UPDATE, {
		action: updateActions.MOVE,
		features: this.getSelected().map(f => f.toGeoJSON())
	});
};

roadMode.simplify = function(polygon) {
	const tolerance = 1 / Math.pow(1.05, 100 * this.map.getZoom()); // https://www.desmos.com/calculator/nolp0g6pwr
	simplify(polygon, {
		mutate: true,
		tolerance: tolerance,
		highQuality: true
	});
}

roadMode.onStop = function (state) {
	DrawLineString.onStop.call(this, state)
	setTimeout(() => {
		if(this.onFinish)
			this.onFinish();
	}, 0);
};
	
export default roadMode